<app-side-menu>
  <div class="vehicle-rental-details-content">
    <!-- Header -->
    <div class="row mb-4" *ngIf="!isLoading && vehicleRental">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <app-button 
                text="Voltar"
                color="var(--secondary-color)"
                (buttonClick)="goBack()"
                className="me-3">
                <i class="fas fa-arrow-left me-2"></i>
              </app-button>
              <div>
                <h1 class="page-title">
                  <i class="fas fa-file-contract me-3"></i>
                  Locação {{ vehicleRental.rentalNumber }}
                </h1>
                <p class="page-subtitle mb-0">Detalhes completos da locação</p>
              </div>
            </div>
            <div class="status-badge">
              <span [ngClass]="getStatusClass(vehicleRental.status)">
                {{ vehicleRental.status }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <app-loading [show]="isLoading" message="Carregando detalhes da locação..."></app-loading>

    <!-- Content -->
    <div *ngIf="!isLoading && vehicleRental" class="row">
      <div class="col-12">
        <div class="details-card">
          <!-- Action Buttons -->
          <div class="action-buttons mb-4">
            <div class="d-flex gap-2 flex-wrap">
              <button *appHasPermission="'VehicleRentals.Edit'" type="button" class="btn btn-primary" (click)="editRental()" [disabled]="!canEditRental()">
                <i class="fas fa-edit me-2"></i>
                Editar
              </button>
              <button *appHasPermission="'VehicleRentals.Approve'" type="button" class="btn btn-info" (click)="goToApproval()" [disabled]="!canApproveRental()">
                <i class="fas fa-gavel me-2"></i>
                Aprovar
              </button>
              <button type="button" class="btn btn-success" (click)="startRental()" [disabled]="!canStartRental()">
                <i class="fas fa-play me-2"></i>
                Iniciar
              </button>
              <button type="button" class="btn btn-warning" (click)="endRental()" [disabled]="!canEndRental()">
                <i class="fas fa-stop me-2"></i>
                Finalizar
              </button>
              <button type="button" class="btn btn-danger" (click)="cancelRental()" [disabled]="!canCancelRental()">
                <i class="fas fa-times me-2"></i>
                Cancelar
              </button>
              <ng-container *ngIf="vehicleRental.status?.toLowerCase() === 'cancelada'">
                <button
                  *appHasPermission="'Agreements.Create'"
                  type="button"
                  class="btn btn-outline-primary"
                  (click)="createAgreement()">
                  <i class="fas fa-handshake me-2"></i>
                  Criar Acordo
                </button>
              </ng-container>
            </div>
          </div>

          <!-- Navigation Tabs -->
          <ul class="nav nav-tabs">
            <li class="nav-item">
              <button class="nav-link" [class.active]="activeTab === 'overview'" (click)="setActiveTab('overview')">
                <i class="fas fa-eye me-2"></i>
                Visão Geral
              </button>
            </li>
            <li class="nav-item">
              <button class="nav-link" [class.active]="activeTab === 'items'" (click)="setActiveTab('items')">
                <i class="fas fa-car me-2"></i>
                Veículos
              </button>
            </li>
            <li class="nav-item">
              <button class="nav-link" [class.active]="activeTab === 'history'" (click)="setActiveTab('history')">
                <i class="fas fa-history me-2"></i>
                Histórico
              </button>
            </li>
            <li class="nav-item">
              <button class="nav-link" [class.active]="activeTab === 'attachments'" (click)="setActiveTab('attachments')">
                <i class="fas fa-paperclip me-2"></i>
                Anexos
              </button>
            </li>
          </ul>

          <!-- Tab Content -->
          <div class="tab-content">
            <!-- Overview Tab -->
            <div *ngIf="activeTab === 'overview'" class="tab-pane active">
              <div class="row g-4">
                <!-- Basic Information -->
                <div class="col-md-6">
                  <div class="info-card">
                    <h5 class="card-title">
                      <i class="fas fa-info-circle me-2"></i>
                      Informações Básicas
                    </h5>
                    <div class="card-content">
                      <div class="info-row">
                        <span class="label">Número:</span>
                        <span class="value">{{ vehicleRental.rentalNumber }}</span>
                      </div>
                      <div class="info-row">
                        <span class="label">Status:</span>
                        <span class="value">
                          <span [ngClass]="getStatusClass(vehicleRental.status)">
                            {{ vehicleRental.status }}
                          </span>
                        </span>
                      </div>
                      <div class="info-row">
                        <span class="label">Prioridade:</span>
                        <span class="value">
                          <span [ngClass]="getPriorityClass(vehicleRental.priority)">
                            {{ vehicleRental.priority }}
                          </span>
                        </span>
                      </div>
                      <div class="info-row">
                        <span class="label">Data de Início:</span>
                        <span class="value">{{ formatDate(vehicleRental.startDate) }}</span>
                      </div>
                      <div class="info-row">
                        <span class="label">Data de Fim:</span>
                        <span class="value">{{ formatDate(vehicleRental.endDate) }}</span>
                      </div>
                      
                    </div>
                  </div>
                </div>

                <!-- Customer Information -->
                <div class="col-md-6">
                  <div class="info-card">
                    <h5 class="card-title">
                      <i class="fas fa-user me-2"></i>
                      Cliente e Motorista
                    </h5>
                    <div class="card-content">
                      <div class="info-row">
                        <span class="label">Cliente:</span>
                        <span class="value">{{ vehicleRental.customerName || 'Não informado' }}</span>
                      </div>
                      <div class="info-row">
                        <span class="label">Motorista:</span>
                        <span class="value">{{ vehicleRental.driverName || 'Não informado' }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Notes -->
                <div class="col-12" *ngIf="vehicleRental.notes">
                  <div class="info-card">
                    <h5 class="card-title">
                      <i class="fas fa-sticky-note me-2"></i>
                      Observações
                    </h5>
                    <div class="card-content">
                      <div class="info-row">
                        <span class="value">{{ vehicleRental.notes }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Items Tab -->
            <div *ngIf="activeTab === 'items'" class="tab-pane active">
              <div *ngIf="rentalItems.length > 0">
                <div class="table-responsive">
                  <table class="table table-hover">
                    <thead class="table-light">
                      <tr>
                        <th>Veículo</th>
                        <th>Marca/Modelo</th>
                        <th>Km Inicial</th>
                        <th>Km Final</th>
                        <th>Condição</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of rentalItems">
                        <td>{{ item.plateNumber }}</td>
                        <td>{{ item.brand }} {{ item.model }}</td>
                        <td>{{ item.startMileage }}</td>
                        <td>{{ item.endMileage || 'N/A' }}</td>
                        <td>{{ item.conditionAtStart || 'N/A' }}</td>
                        <td>
                          <span [ngClass]="getStatusClass(item.status)">
                            {{ item.status }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div *ngIf="rentalItems.length === 0" class="text-center py-4">
                <i class="fas fa-car fa-3x text-muted mb-3"></i>
                <p class="text-muted">Nenhum veículo encontrado para esta locação.</p>
              </div>
            </div>

            <!-- History Tab -->
            <div *ngIf="activeTab === 'history'" class="tab-pane active">
              <div class="history-container">
                <h5 class="mb-3">
                  <i class="fas fa-history me-2"></i>
                  Histórico da Locação
                </h5>

                <!-- Loading -->
                <div *ngIf="isLoadingHistory" class="text-center py-4">
                  <div class="spinner-border spinner-border-sm text-primary" role="status">
                    <span class="visually-hidden">Carregando...</span>
                  </div>
                  <p class="mt-2 text-muted">Carregando histórico...</p>
                </div>

                <!-- Empty State -->
                <div *ngIf="!isLoadingHistory && history.length === 0" class="text-center py-4">
                  <i class="fas fa-history fa-3x text-muted mb-3"></i>
                  <p class="text-muted">Nenhum histórico encontrado.</p>
                </div>

                <!-- History Timeline -->
                <div *ngIf="!isLoadingHistory && history.length > 0" class="timeline">
                  <div class="timeline-item" *ngFor="let item of history; let last = last">
                    <div class="timeline-marker">
                      <i [class]="getHistoryIconClass(item.action)"></i>
                    </div>
                    <div class="timeline-content">
                      <div class="timeline-header">
                        <span class="badge" [class]="getHistoryBadgeClass(item.action)">
                          {{ item.description }}
                        </span>
                        <small class="text-muted ms-2">
                          {{ formatDate(item.actionDate) }} às {{ item.actionDate | date:'HH:mm' }}
                        </small>
                      </div>
                      <div class="timeline-body" *ngIf="item.notes">
                        <p class="mb-1">{{ item.notes }}</p>
                      </div>
                      <div class="timeline-footer">
                        <small class="text-muted">
                          <i class="fas fa-user me-1"></i>
                          {{ item.staffName }}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Attachments Tab -->
            <div *ngIf="activeTab === 'attachments'" class="tab-pane active">
              <div class="attachments-container">
                <h5 class="mb-3">
                  <i class="fas fa-paperclip me-2"></i>
                  Anexos da Locação
                </h5>

                <!-- Loading -->
                <div *ngIf="isLoadingAttachments" class="text-center py-4">
                  <div class="spinner-border spinner-border-sm text-primary" role="status">
                    <span class="visually-hidden">Carregando...</span>
                  </div>
                  <p class="mt-2 text-muted">Carregando anexos...</p>
                </div>

                <!-- Empty State -->
                <div *ngIf="!isLoadingAttachments && attachments.length === 0" class="text-center py-4">
                  <i class="fas fa-paperclip fa-3x text-muted mb-3"></i>
                  <p class="text-muted">Nenhum anexo encontrado.</p>
                </div>

                <!-- Attachments List -->
                <div *ngIf="!isLoadingAttachments && attachments.length > 0" class="attachments-list">
                  <div class="attachment-item" *ngFor="let attachment of attachments">
                    <div class="attachment-icon">
                      <i [class]="getAttachmentIconClass(attachment.fileName)"></i>
                    </div>
                    <div class="attachment-info">
                      <h6 class="attachment-name">{{ attachment.fileName }}</h6>
                      <p class="attachment-details">
                        <span class="badge bg-secondary me-2">{{ attachment.category }}</span>
                        <small class="text-muted">
                          {{ formatFileSize(attachment.fileSize) }} • 
                          {{ formatDate(attachment.uploadDate) }}
                        </small>
                      </p>
                    </div>
                    <div class="attachment-actions">
                      <button class="btn btn-sm btn-outline-primary" (click)="downloadAttachment(attachment)">
                        <i class="fas fa-download"></i>
                      </button>
                      <button class="btn btn-sm btn-outline-danger" (click)="deleteAttachment(attachment)">
                        <i class="fas fa-trash"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>
